import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Drawer, List, Table } from "antd";
import { useEffect, useRef, useState } from "react";
import { BiSolidErrorAlt } from "react-icons/bi";
import { FaBackward } from "react-icons/fa";
import { FaCirclePlus } from "react-icons/fa6";
import { FiClock } from "react-icons/fi";
import { IoClose, IoWarningOutline } from "react-icons/io5";
import { LuUserRoundPlus } from "react-icons/lu";
import { PiSealCheck } from "react-icons/pi";
import { TbDeviceRemote } from "react-icons/tb";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import addClock from "../../../assets/images/addClock.png";
import assetsAssignImg from "../../../assets/images/car.png";
import imagePlaceholder from "../../../assets/images/imageplace.jpg";
import questionIcon from "../../../assets/images/questionIcon.png";
import mapImg from "../../../assets/images/staticImages/map.png";
import m1 from "../../../assets/images/staticImages/md1.png";
import {
  Dropdown,
  InputField,
  Modal,
  SearchInput,
  SubmitButton,
  TextComponent,
  TimeInput,
} from "../../../components";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import { showAlert } from "../../../Store/Actions/GeneralActions";
import { AssetsMiddleware } from "../../../Store/Middlewares/AssetsMiddleware";
import { validateEmail } from "../../../utills/Validators";
import AddAssets from "../AssetsManagement/AddAssets/AddAssets";
import styles from "./Inventory.module.css";

const Inventory = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const ref = useRef();
  const { width } = useWindowDimensions();
  const [open, setOpen] = useState(false);
  const [isDrive, setIsDrive] = useState(true);
  const [accessEmail, setAccessEmail] = useState("");
  const [accessFirstName, setAccessFirstName] = useState("");
  const [accessLastName, setAccesslastName] = useState("");
  const [licenseDur, setLicenseDur] = useState("");
  const [details, setDetails] = useState([]);
  const [accessSharingModal, setAccessSharingModal] = useState(false);
  const [soldModal, setSoldModal] = useState(false);
  const [accessSuccessModal, setAccessSuccessModal] = useState(false);
  const [accessDeniedModal, setAccessDeniedModal] = useState(false);
  const [scheduleModal, setScheduleModal] = useState(false);
  const [frequency, setFrequency] = useState("One time");
  const [scheduleSuccessModal, setScheduleSuccessModal] = useState(false);
  const [scheduleDeniedModal, setScheduleDeniedModal] = useState(false);
  const [removeModuleModal, setRemoveModuleModal] = useState(false);
  const [moduleSuccessModal, setModuleSuccessModal] = useState(false);
  const [assignAssetsModal, setAssignAssetsModal] = useState(false);
  const [assetsSuccessModal, setAssetsSuccessModal] = useState(false);
  const [locationTracking, setLocationTracking] = useState(false);
  const [openAddAssetsModal, setOpenAddAssetsModal] = useState(false);
  const [activeAssign, setActiveAssign] = useState(false);
  const [moduleId, setModuleId] = useState(null);
  const [moduleImage, setModuleImage] = useState(null);
  const moduleImageref = useRef();

  const [addModule, setAddModule] = useState(false);
  const [device_name, setDevice_name] = useState("");
  const [device_id, setDevice_id] = useState("");
  const [carStatus, setCarStatus] = useState(null);
  const [dealerShipStatus, setDealerShipStatus] = useState(null);
  const [emailError, setEmailError] = useState("");
  const Modules = useSelector((state) => state.AssetsReducer.getModules);
  const ModulesPagination = useSelector(
    (state) => state.AssetsReducer.getModulesPagination,
  );
  const getUnlinkAssets = useSelector(
    (state) => state.AssetsReducer.getUnlinkAssets,
  );
  const user = useSelector((state) => state.AuthReducer.user);
  const add_asset = user?.permissions?.find((x) => x?.name == "add_asset");
  const report = user?.permissions?.find((x) => x?.name == "reports");
  const pair_unpair_device = user?.permissions?.find(
    (x) => x?.name == "pair_unpair_device",
  );

  const access_sharing = user?.permissions?.find(
    (x) => x?.name == "access_sharing",
  );

  const getData = (name) => {
    dispatch(AssetsMiddleware.getModules({ name, url: undefined })).then(
      (data) => {
        setActiveAssign(false);
      },
    );
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    dispatch(AssetsMiddleware.getUnlinkAssets()).then((data) => {});
  }, [assignAssetsModal]);

  const onSearch = (e) => {
    setSearch(e.target.value);
    const value = e.target.value;
    clearTimeout(ref.current);
    ref.current = setTimeout(() => {
      if (activeAssign) {
        dispatch(
          AssetsMiddleware.getAssignDevices({ name: value, url: undefined }),
        ).then((data) => {});
      } else {
        dispatch(
          AssetsMiddleware.getModules({ name: value, url: undefined }),
        ).then((data) => {});
      }
    }, 1000);
  };

  const onCreateModule = () => {
    let userData = {
      device_id,
      // device_name,
      // moduleImage,
    };
    if (!device_id) {
      dispatch(
        showAlert({
          type: "Error",
          message: "Device ID is required",
        }),
      );
    } else {
      dispatch(AssetsMiddleware.createModules(userData)).then(() => {
        setAddModule(false);
      });
    }
  };

  const onGetDetail = (id) => {
    dispatch(AssetsMiddleware.getModuleDetails(id)).then((data) => {
      setDetails(data?.data?.data);
      setOpen(true);
    });
  };

  const onExportDevices = () => {
    dispatch(AssetsMiddleware.exportDevices()).then((data) => {
      const url = data?.data?.data?.url;
      if (url) {
        window.open(url, "_blank");
      }
    });
  };

  const onHistoryClick = (module_id) => {
    dispatch(AssetsMiddleware.getHistoryDevices({ moduleId: module_id })).then(
      (data) => {},
    );
  };

  const onAssignDevices = (name) => {
    setActiveAssign((prev) => !prev);
    dispatch(AssetsMiddleware.getAssignDevices(name)).then((data) => {});
  };

  const onUnassignDevices = (name) => {
    setActiveAssign((prev) => !prev);
    getData(name);
  };

  const pagecalculation = () => {
    if (!ModulesPagination?.meta) {
      return 0;
    }
    return (
      (ModulesPagination?.meta?.current_page - 1) *
      ModulesPagination?.meta?.per_page
    );
  };

  const switchDevices = (activeAssign, moduleId, url) => {
    switch (activeAssign) {
      case true:
        return dispatch(
          AssetsMiddleware.getAssignDevices({ name: search, url }),
        ).then((data) => {});
      case false:
        return dispatch(
          AssetsMiddleware.getModules({ name: search, url }),
        ).then((data) => {});
      case moduleId:
        return dispatch(
          AssetsMiddleware.getHistoryDevices({ moduleId, url }),
        ).then((data) => {});
      default:
        return setActiveAssign(false);
    }
  };

  const onClickSharing = () => {
    let userData = {
      email: accessEmail,
      assetId: details?.asset_id,
      moduleId: details?.id,
      first_name: accessFirstName,
      last_name: accessLastName,
      type: soldModal ? "sold" : "temporary",
    };
    if (soldModal) {
      userData["license_key"] = details?.license_no;
      userData["license_duration"] = licenseDur;
    }

    if (!accessEmail || !accessFirstName || !accessLastName) {
      dispatch(
        showAlert({ type: "Error", message: "All fields are required" }),
      );
    } else {
      dispatch(AssetsMiddleware.dealerShareAccess(userData))
        .then(() => {
          setAccessSharingModal(false);
          setAccessSuccessModal(true);
          setOpen(false);
          setDetails([]);
          setAccessEmail("");
          setAccessFirstName("");
          setAccesslastName("");
          setSoldModal(false);
        })
        .catch(() => {
          setAccessDeniedModal(true);
        });
    }
  };

  let car_status = [
    { id: 1, value: "New" },
    { id: 1, value: "Used" },
    { id: 1, value: "Loaner" },
    { id: 1, value: "Demo" },
  ];

  let dealershipStatus = [
    { id: 1, value: "Pending" },
    { id: 1, value: "Install" },
    { id: 1, value: "Stock" },
  ];

  const history = [
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text, data, index) => (
        <div className={styles.dealerDiv}>
          <SubmitButton
            title={"History"}
            className={styles.deleteBtn}
            onClick={(e) => {
              e.stopPropagation();
              setModuleId(data);
              onHistoryClick(data?.id);
            }}
          />
        </div>
      ),
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      render: (text, data, index) => (
        <div>
          <TextComponent
            text={`${pagecalculation() + index + 1}`}
            className={styles.versionText}
          />
        </div>
      ),
    },
    {
      title: "Device",
      dataIndex: "module",
      key: "module",
      render: (item, data) => (
        <div className={styles.module}>
          <img
            src={data?.image ? data?.image : m1}
            className={styles.moduleImg}
          />
          <TextComponent
            text={data?.device_id ? data?.device_id : "--"}
            className={styles.moduletext}
          />
        </div>
      ),
    },
    {
      title: "Device Name",
      dataIndex: "device_name",
      key: "device_name",
      render: (item, data) => (
        <div className={styles.module}>
          <TextComponent text={data?.device_name ? data?.device_name : "--"} />
        </div>
      ),
    },
    {
      title: "Dev EUI",
      dataIndex: "dev_eui",
      key: "dev_eui",
      render: (item, data) => (
        <div className={styles.module}>
          <TextComponent text={data?.dev_eui ? data?.dev_eui : "--"} />
        </div>
      ),
    },
    {
      title: "Join EUI",
      dataIndex: "join_eui",
      key: "join_eui",
      render: (item, data) => (
        <div className={styles.module}>
          <TextComponent text={data?.join_eui ? data?.join_eui : "--"} />
        </div>
      ),
    },
    // {
    //   title: "Vehicle",
    //   dataIndex: "car",
    //   key: "car",
    //   render: (item, data) => (
    //     <>
    //       {data?.asset == null ? (
    //         <TextComponent text={"Not Connected"} className={styles.nulltext} />
    //       ) : (
    //         <div className={styles.module}>
    //           <img
    //             src={data?.image ? data?.image : imagePlaceholder}
    //             className={styles.moduleImg}
    //           />
    //           <TextComponent
    //             text={data?.name ? data?.name : "--"}
    //             className={styles.moduletext}
    //           />
    //         </div>
    //       )}
    //     </>
    //   ),
    // },
    // {
    //   title: "Car Status",
    //   dataIndex: "car_status",
    //   key: "car_status",
    //   render: (text, item) => (
    //     <div className={styles.carDiv} onClick={(e) => e.stopPropagation()}>
    //       <Dropdown
    //         value={item?.shared_access ? "Sold" : text ? text : "--"}
    //         inputClass={styles.carDropDown}
    //         options={car_status}
    //         onChange={(e) => {
    //           setCarStatus(e);
    //           dispatch(
    //             AssetsMiddleware.updateCarStatus({
    //               id: item?.id,
    //               carStatus: e?.value,
    //             }),
    //           );
    //         }}
    //         disabled={
    //           item?.asset == null ||
    //           item?.shared_access ||
    //           add_asset?.is_access == 0 ||
    //         }
    //       />
    //       {/* <TextComponent text={text ? text : "--"} className={styles.text} /> */}
    //     </div>
    //   ),
    // },
    // {
    //   title: "Dealership Status",
    //   dataIndex: "dealership_status",
    //   key: "dealership_status",
    //   render: (text, item) => (
    //     <div className={styles.carDiv} onClick={(e) => e.stopPropagation()}>
    //       <Dropdown
    //         value={text ? text : "--"}
    //         inputClass={styles.carDropDown}
    //         options={dealershipStatus}
    //         onChange={(e) => {
    //           setDealerShipStatus(e);
    //           dispatch(
    //             AssetsMiddleware.updateDealershipStatus({
    //               id: item?.id,
    //               dealerShipStatus: e?.value,
    //             }),
    //           );
    //         }}
    //         disabled={add_asset?.is_access == 0}
    //       />
    //     </div>
    //   ),
    // },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text, data, index) =>
        data?.ro_number ? (
          <div className={styles.action_col}>
            <BiSolidErrorAlt size={20} color="red" />
            <TextComponent
              text={data?.ro_number}
              className={styles.moduletext}
            />
          </div>
        ) : (
          <TextComponent text={"-"} />
        ),
    },
  ];

  return (
    <div className={styles.upperCont}>
      <div className={styles.mainCont}>
        <div className={styles.header}>
          <div className={styles.headerinner}>
            {moduleId && (
              <FaBackward
                onClick={(e) => {
                  e.preventDefault();
                  setModuleId(null);
                  setActiveAssign(false);
                  getData();
                }}
                size={20}
                style={{
                  marginRight: "10px",
                  cursor: "pointer",
                }}
              />
            )}
            <TextComponent
              text={
                moduleId
                  ? `Device Inventory History - ${moduleId?.device_id}`
                  : `Device Inventory`
              }
              className={styles.headerHeading}
            />
          </div>

          {!moduleId && (
            <div className={styles.rightHeader}>
              <div className={styles.searchInput}>
                <SearchInput onChange={(e) => onSearch(e)} />
                <TextComponent
                  text={`Devices: ${Modules?.length > 0 ? Modules?.length : "0"}`}
                  className={styles.headingcount}
                />
              </div>

              {/* <div className={styles.headerBtn}  onClick={()=>navigate("/salesHistory")}>
              <img src={saleIcon} className={styles.saleIcon} />
              <TextComponent
                text={"Sales history"}
                className={styles.headerBtnText}
              />
            </div> */}
            </div>
          )}
        </div>
        <div className={styles.tableDiv}>
          {/* {!moduleId && (
            <div className={"flex-end"}>
              <div
                className={styles.importBtn}
                onClick={(e) => {
                  e.stopPropagation();
                  activeAssign && onUnassignDevices();
                }}
                style={{
                  backgroundColor: !activeAssign
                    ? "var(--secondary-color)"
                    : "var(--light-grey)",
                  opacity: !activeAssign ? 0.8 : 1,
                  cursor: !activeAssign ? "not-allowed" : "pointer",
                }}
                disabled={!activeAssign}
              >
                <MdPending title={"Unassigned"} />
                <TextComponent text={"Unassigned"} />
              </div>

              <div
                className={styles.importBtn}
                onClick={(e) => {
                  e.stopPropagation();
                  !activeAssign && onAssignDevices();
                }}
                style={{
                  backgroundColor: activeAssign
                    ? "var(--secondary-color)"
                    : "var(--light-grey)",
                  opacity: activeAssign ? 0.8 : 1,
                  cursor: activeAssign ? "not-allowed" : "pointer",
                }}
                disabled={activeAssign}
              >
                <CgAssign title={"Assigned"} />
                <TextComponent text={"Assigned"} />
              </div>
            </div>
          )} */}
          <Table
            //   title={}
            scroll={{ x: true }}
            bordered={false}
            pagination={{
              showSizeChanger: false,
              showQuickJumper: false,
              current: ModulesPagination?.meta?.current_page,
              pageSize: ModulesPagination?.meta?.per_page,
              total: ModulesPagination?.meta?.total,
              onChange: (page, pageSize) => {
                dispatch(
                  AssetsMiddleware.getSingleAssets({
                    url: `${ModulesPagination?.meta?.path}?page=${page}`,
                  }),
                );
              },
              itemRender: (_, type, originalElement) => {
                if (type === "prev") {
                  return (
                    <span
                      style={{
                        color: ModulesPagination?.links?.prev
                          ? "inherit"
                          : "#ccc",
                        cursor: ModulesPagination?.links?.prev
                          ? "pointer"
                          : "not-allowed",
                      }}
                      onClick={() => {
                        switchDevices(
                          activeAssign,
                          moduleId,
                          ModulesPagination?.links?.prev,
                        );
                        // dispatch(
                        //   AssetsMiddleware.getModules({
                        //     name: search,
                        //     url: ModulesPagination?.links?.prev,
                        //   }),
                        // );
                      }}
                    >
                      <LeftOutlined /> Prev
                    </span>
                  );
                }
                if (type === "next") {
                  return (
                    <span
                      style={{
                        color: ModulesPagination?.links?.next
                          ? "inherit"
                          : "#ccc",
                        cursor: ModulesPagination?.links?.next
                          ? "pointer"
                          : "not-allowed",
                      }}
                      onClick={() => {
                        switchDevices(
                          activeAssign,
                          moduleId,
                          ModulesPagination?.links?.next,
                        );
                        // dispatch(
                        //   AssetsMiddleware.getModules({
                        //     name: search,
                        //     url: ModulesPagination?.links?.next,
                        //   }),
                        // );
                      }}
                    >
                      Next <RightOutlined />
                    </span>
                  );
                }
                return originalElement;
              },
            }}
            // }}
            columns={columns}
            dataSource={Modules}
            onRow={(record, rowIndex) => {
              return {
                onClick:
                  (add_asset?.is_access == 1 || user?.is_owner) && !moduleId
                    ? () => onGetDetail(record?.id)
                    : null,
                style: {
                  cursor:
                    add_asset?.is_access == 1 || user?.is_owner
                      ? "pointer"
                      : "default",
                },
              };
            }}
            // rowSelection={}
          />
        </div>
      </div>
      {/* {add_asset?.is_access == 1 || user?.is_owner ? (
        <>
          {width > 550 ? (
            <div
              className={styles.addNewBtn}
              // onClick={() => navigate("/moduleRegistration")}
              onClick={() => setAddModule(true)}
            >
              <FiPlusCircle size={18} style={{ marginRight: "5px" }} />
              <TextComponent text={"Add new Device"} />
            </div>
          ) : (
            <div
              className={styles.addNewResponsiveBtn}
              onClick={() => setAddModule(true)}
              // onClick={() => navigate("/moduleRegistration")}
            >
              <FaCirclePlus size={60} style={{ marginRight: "5px" }} />
            </div>
          )}
        </>
      ) : null} */}

      {user?.is_owner || report?.is_access == 1 ? (
        <div className={styles.floatingBtn} onClick={onExportDevices}>
          <TextComponent text={"Export Devices"} />
        </div>
      ) : null}

      <Drawer
        width={width < 550 ? "100%" : 600}
        headerStyle={{ display: "none" }}
        onClose={() => {
          setOpen(false);
          setDetails([]);
        }}
        open={open}
      >
        <div className={styles.drawerImgDiv}>
          <img
            src={details?.image ? details?.image : m1}
            className={styles.drawerImg}
          />
          <div
            className={styles.crossIconDiv}
            onClick={() => {
              setOpen(false);
              setDetails([]);
            }}
          >
            <IoClose />
          </div>
        </div>
        <div className={styles.titleDiv}>
          {/* <TextComponent
            style={{
              fontSize: "var(--mobile-heading)",
              fontFamily: "Urbanist-semibold",
            }}
            text={details?.device_name}
          /> */}
          <TextComponent
            style={{
              fontSize: "var(--mobile-heading)",
              fontFamily: "Urbanist-semibold",
            }}
            text={details?.device_id}
          />
        </div>
        {/* <div className={styles.drawerDealerDiv}>
          <TextComponent
            style={{ fontFamily: "Urbanist-bold" }}
            text={"Dealership status"}
          />
          <div style={{ width: "30%" }}>
            <Dropdown
              inputClass={styles.carDropDown}
              value={
                details?.dealership_status ? details?.dealership_status : "--"
              }
              options={dealershipStatus}
              onChange={(e) => {
                setDealerShipStatus(e);
                dispatch(
                  AssetsMiddleware.updateDealershipStatus({
                    id: details?.id,
                    dealerShipStatus: e?.value,
                  }),
                );
              }}
            />
          </div>
        </div> */}
        {/* <div className={styles.batteryBox}>
          <TextComponent text={"Version: "}>
            <text style={{ fontFamily: "Urbanist-bold" }}>
              {details?.version}
            </text>
          </TextComponent>
          <BatteryStatus percentage={details?.battery} />
        </div> */}

        {details?.asset != null ? (
          <div className={styles.drawerCarDiv}>
            <div className={styles.drawerCarDivLeft}>
              <img
                src={
                  details?.asset?.image
                    ? details?.asset?.image
                    : imagePlaceholder
                }
                className={styles.drawerCarImg}
              />
              <div>
                <div className={styles.leftHeader}>
                  {details?.name && (
                    <TextComponent
                      text={`${details?.name ? details?.name : "-"}`}
                      className={styles.heading}
                    />
                  )}
                  {details?.make && (
                    <TextComponent
                      text={`${details?.make ? details?.make : "-"} `}
                      className={styles.heading}
                    />
                  )}
                  {details?.license_no && (
                    <TextComponent
                      text={`License Plate: ${details?.license_no}`}
                      className={styles.carDescText}
                    />
                  )}
                  {details?.vin_no && (
                    <TextComponent
                      text={`VIN: ${details?.vin_no}`}
                      className={styles.carDescText}
                    />
                  )}
                  {details?.model && (
                    <TextComponent
                      text={`Model: ${details?.model}`}
                      className={styles.carDescText}
                    />
                  )}
                  {/* <TextComponent text={"2016"] className={styles.carDescText} /> */}
                  {/* <TextComponent
                  text={"Location: Lot A, Row 5"}
                  className={styles.carDescText}
                /> */}
                </div>
                <div className={styles.leftHeader}>
                  {details?.color && (
                    <TextComponent
                      text={`Color: ${details?.color}`}
                      className={styles.carDescText}
                    />
                  )}
                  {details?.trim && (
                    <TextComponent
                      text={`Trim: ${details?.trim}`}
                      className={styles.carDescText}
                    />
                  )}
                  {details?.stock_no && (
                    <TextComponent
                      text={`Stock No: ${details?.stock_no}`}
                      className={styles.carDescText}
                    />
                  )}
                  {details?.year && (
                    <TextComponent
                      text={`Year: ${details?.year}`}
                      className={styles.carDescText}
                    />
                  )}
                </div>
                {/* <div style={{ width: "50%" }}> */}
                <Dropdown
                  value={
                    details?.shared_access
                      ? "Sold"
                      : details?.car_status
                        ? details?.car_status
                        : "--"
                  }
                  inputClass={styles.drawerCarText}
                  options={car_status}
                  onChange={(e) => {
                    setCarStatus(e);
                    dispatch(
                      AssetsMiddleware.updateCarStatus({
                        id: details?.id,
                        carStatus: e?.value,
                      }),
                    );
                  }}
                  disabled={details?.shared_access}
                />
                {/* </div> */}
              </div>
            </div>
            {/* <div className={styles.drawerCarDivRight}>
                <HiOutlineDotsVertical
                  color={"var(--input-icon)"}
                  size={20}
                  style={{ cursor: "pointer" }}
                />
                <FiArrowRightCircle
                  color={"var(--secondary-color)"}
                  size={25}
                  style={{ cursor: "pointer", marginTop: "10px" }}
                />
              </div> */}
          </div>
        ) : (
          (pair_unpair_device?.is_access == 1 || user?.is_owner) && (
            <div className={styles.drawerCarDiv}>
              <div
                className={styles.emptyAssets}
                onClick={() => setAssignAssetsModal(true)}
              >
                <FaCirclePlus
                  size={18}
                  color="var(--secondary-color)"
                  style={{ marginRight: "5px" }}
                />
                <TextComponent
                  text={"Assign Vehicle"}
                  style={{
                    color: "var(--secondary-color)",
                    fontFamily: "Urbanist-bold",
                  }}
                />
              </div>
            </div>
          )
        )}

        {/* <div className={styles.AccessDiv}>
          <TextComponent
            style={{
              fontFamily: "Urbanist-bold",
              fontSize: "var(--paragraph-font-size)",
            }}
            text={"Access details"}
          />
          {details?.shared_access == null ? (
            access_sharing?.is_access === 0 ? null : (
              <div className={styles.Access_Owner}>
                <TextComponent
                  style={{ color: "var( --light-text)" }}
                  text={`Owner: ${"You"}`}
                />
                <div>
                  <TextComponent
                    onClick={() => {
                      if (!details?.asset_id) {
                        dispatch(
                          showAlert({
                            type: "Error",
                            message: "Can't found asset",
                          }),
                        );
                      } else {
                        setAccessSharingModal(true);
                      }
                    }}
                    className={styles.access_sharedBtn}
                    text={"Share Temporary Access"}
                  />
                  <TextComponent
                    onClick={() => {
                      if (!details?.asset_id) {
                        dispatch(
                          showAlert({
                            type: "Error",
                            message: "Can't found asset",
                          }),
                        );
                      } else {
                        setSoldModal(true);
                      }
                    }}
                    className={styles.access_sharedBtn}
                    text={"Sell Through"}
                  />
                </div>
              </div>
            )
          ) : (
            // <>
            //   <List
            //     className={styles.access_list}
            //     dataSource={dummySharedAccess}
            //     renderItem={(item, index) => (
            <div className={styles.access_listItem}>
              <div className={styles.access_listLeft}>
                <img
                  src={
                    details?.shared_access?.profile_picture
                      ? details?.shared_access?.profile_picture
                      : dummyImg
                  }
                />
                <TextComponent
                  style={{
                    fontSize: "var(--mobile-heading)",
                    fontFamily: "Urbanist-semibold",
                  }}
                  text={
                    details?.shared_access?.email
                      ? details?.shared_access?.email
                      : ""
                  }
                />
              </div>
              <div
                className={styles.access_remove}
                onClick={() => {
                  dispatch(
                    AssetsMiddleware.dealerRemoveAccess({
                      assetId: details?.asset_id,
                      userId: details?.shared_access?.id,
                    }),
                  ).then(() => setOpen(false));
                }}
              >
                <TextComponent text={"Remove"} />
              </div>
            </div>
            //     )}
            //   />
            // </>
          )}
        </div> */}

        {/* <div className={styles.schedule_box}>
          <div className={styles.schedule_header}>
            <TextComponent
              style={{
                fontFamily: "Urbanist-bold",
                fontSize: "var(--paragraph-font-size)",
              }}
              text={"Schedule"}
            />
            <div
              className={styles.schedule_addBtn}
              onClick={() => setScheduleModal(true)}
            >
              <TextComponent text={"Add"} />
              <HiMiniPlusCircle color={"var(--primary-color)"} />
            </div>
          </div>
          <List
            dataSource={dummySchedule}
            renderItem={(item, index) => (
              <div key={index} className={styles.schedule_listItem}>
                <div className={styles.schedule_listheader}>
                  <TextComponent
                    text={item?.name}
                    style={{ fontFamily: "Urbanist-semibold" }}
                  />
                  <HiOutlineDotsVertical
                    color={"var(--input-icon)"}
                    size={15}
                    style={{ cursor: "pointer" }}
                  />
                </div>
                <div className={styles.schedule_listDateTime}>
                  <TextComponent
                    text={`${item?.day} `}
                    style={{
                      color: "var(--light-text)",
                      fontSize: "var(--mobile-sub-heading)",
                    }}
                  />
                  <TextComponent
                    text={item?.time}
                    style={{ fontSize: "var(--mobile-sub-heading)" }}
                  />
                </div>
              </div>
            )}
          />
        </div> */}
        {/* {details?.shared_access == null &&
        (user?.is_owner || add_asset?.is_access == 1) ? (
          <div
            className={styles.remove_module}
            onClick={() => setRemoveModuleModal(true)}
          >
            <RiDeleteBin6Line
              color={"var(--light-text)"}
              style={{ marginRight: "5px" }}
            />
            <TextComponent
              text={"Remove this device"}
              style={{ fontFamily: "Urbanist-semibold" }}
            />
          </div>
        ) : null} */}
      </Drawer>

      {/* /////////////////////////Access Sharing///////////////////////// */}

      <Modal
        open={accessSharingModal}
        onCancel={() => setAccessSharingModal(false)}
        imageClass={styles.access_modalImg}
        icon={
          <LuUserRoundPlus
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Temporary Access Sharing"}
        width={"500px"}
        twoButton
        okBtnTitle={"Share"}
        cancelBtnTitle={"Go back"}
        btnDiv={styles.access_modalBtn}
        onClickCancelButton={() => setAccessSharingModal(false)}
        onClickOkButton={onClickSharing}
        buttonDisabled={emailError !== ""}
      >
        <div className={styles.access_modalBox}>
          <div
            style={{
              width: "90%",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <InputField
              style={{ width: "49%" }}
              label={"First Name"}
              value={accessFirstName}
              onChange={(e) => setAccessFirstName(e.target.value)}
              placeholder={"Write here..."}
            />
            <InputField
              style={{ width: "49%" }}
              label={"Last Name"}
              value={accessLastName}
              onChange={(e) => setAccesslastName(e.target.value)}
              placeholder={"Write here..."}
            />
          </div>

          <InputField
            className={styles.access_modalInput}
            label={"Email"}
            value={accessEmail}
            // onChange={(e) => setAccessEmail(e.target.value)}
            placeholder={"chris@email.com"}
            onChange={(e) => {
              setAccessEmail(e.target.value);

              // live validation
              if (!e.target.value) {
                setEmailError("Email is required");
              } else if (!validateEmail(e.target.value)) {
                setEmailError("Enter a valid email address");
              } else {
                setEmailError("");
              }
            }}
            error={emailError}
            type="email"
          />
          {/* <Dropdown
            label={"License Duration"}
            className={styles.access_modalInput}
            value={licenseDur ? licenseDur : "Select Duration"}
           
            onChange={(e)=>setLicenseDur(e?.value)}
            options={[{ id: 1, value: "3 years" }, { id: 1, value: "5 years" }]}
          /> */}
        </div>
      </Modal>
      <Modal
        open={soldModal}
        onCancel={() => setSoldModal(false)}
        imageClass={styles.access_modalImg}
        icon={
          <LuUserRoundPlus
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Sold Device"}
        width={"500px"}
        twoButton
        okBtnTitle={"Sold"}
        cancelBtnTitle={"Go back"}
        btnDiv={styles.access_modalBtn}
        onClickCancelButton={() => setSoldModal(false)}
        onClickOkButton={onClickSharing}
        buttonDisabled={emailError !== ""}
      >
        <div className={styles.access_modalBox}>
          -
          <div
            style={{
              width: "90%",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <InputField
              style={{ width: "49%" }}
              label={"First Name"}
              value={accessFirstName}
              onChange={(e) => setAccessFirstName(e.target.value)}
              placeholder={"Write here..."}
            />
            <InputField
              style={{ width: "49%" }}
              label={"Last Name"}
              value={accessLastName}
              onChange={(e) => setAccesslastName(e.target.value)}
              placeholder={"Write here..."}
            />
          </div>
          <InputField
            className={styles.access_modalInput}
            label={"Email"}
            value={accessEmail}
            // onChange={(e) => setAccessEmail(e.target.value)}
            placeholder={"chris@email.com"}
            onChange={(e) => {
              setAccessEmail(e.target.value);

              // live validation
              if (!e.target.value) {
                setEmailError("Email is required");
              } else if (!validateEmail(e.target.value)) {
                setEmailError("Enter a valid email address");
              } else {
                setEmailError("");
              }
            }}
            error={emailError}
            type="email"
          />
          <Dropdown
            label={"License Duration"}
            className={styles.access_modalInput}
            value={licenseDur ? licenseDur : "Select Duration"}
            onChange={(e) => setLicenseDur(e?.value)}
            options={[
              { id: 1, value: "1 years" },
              { id: 1, value: "3 years" },
              { id: 1, value: "5 years" },
              { id: 1, value: "7 years" },
            ]}
          />
        </div>
      </Modal>

      {/* /////////////////////////Access Successfull///////////////////////// */}

      <Modal
        open={accessSuccessModal}
        onCancel={() => setAccessSuccessModal(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Access Shared successfully"}
        width={"400px"}
        buttonTitle={"Continue"}
        onBtnPress={() => {
          setAccessSuccessModal(false);
        }}
        headingClass={styles.modalHeading}
      ></Modal>

      {/* /////////////////////////Unable to access///////////////////////// */}

      <Modal
        open={accessDeniedModal}
        onCancel={() => setAccessDeniedModal(false)}
        icon={
          <IoWarningOutline
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Unable to  Share Access!"}
        text={" Email not found: k.r.mastrangelo@outlook.com"}
        width={"400px"}
        buttonTitle={"Go back"}
        onBtnPress={() => setAccessDeniedModal(false)}
        // headingClass={styles.modalHeading}
      ></Modal>

      {/* /////////////////////////Schedule Modal///////////////////////// */}

      <Modal
        open={scheduleModal}
        onCancel={() => setScheduleModal(false)}
        icon={
          <img
            src={addClock}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Scheduling"}
        width={"800px"}
        twoButton
        okBtnTitle={"Save"}
        cancelBtnTitle={"Go back"}
        btnDiv={styles.access_modalBtn}
        onClickCancelButton={() => {
          setScheduleModal(false);
          setScheduleDeniedModal(true);
        }}
        onClickOkButton={() => {
          setScheduleModal(false);
          setScheduleSuccessModal(true);
        }}
        btnStyle={{ width: "80%" }}
        // headingClass={styles.modalHeading}
      >
        <div className={styles.schedule_modalMain}>
          <div className={styles.schedule_inputBox}>
            <div className={styles.schedule_input}>
              <TimeInput
                label={"Start time"}
                // value={accessEmail}
                // onChange={(e) => setAccessEmail(e.target.value)}
                // placeholder={""}
                icon={<FiClock color="var(--secondary-color)" />}
              />
            </div>
            <div className={styles.schedule_input}>
              <TimeInput
                label={"End time"}
                // value={accessEmail}
                // onChange={(e) => setAccessEmail(e.target.value)}
                // placeholder={"chris@email.com"}
                icon={<FiClock color="var(--secondary-color)" />}
              />
            </div>
          </div>
          {/* <TextComponent
            text={"Set frequency"}
            style={{
              fontFamily: "Urbanist-semibold",
              fontSize: "var(--mobile-heading)",
            }}
          />
          <div className={styles.schedule_inputBox}>
            <TextComponent
              text={"One time"}
              className={
                frequency == "One time"
                  ? styles.schedule_frequencyBtn
                  : styles.schedule_frequencyUnactiveBtn
              }
              onClick={() => setFrequency("One time")}
            />
            <TextComponent
              text={"Until I turn it off "}
              className={
                frequency == "One time"
                  ? styles.schedule_frequencyUnactiveBtn
                  : styles.schedule_frequencyBtn
              }
              onClick={() => setFrequency("Until change")}
            />
          </div> */}
        </div>
      </Modal>

      {/* /////////////////////////schedule Successfully///////////////////////// */}

      <Modal
        open={scheduleSuccessModal}
        onCancel={() => setScheduleSuccessModal(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Scheduled Successfully"}
        width={"400px"}
        buttonTitle={"Go back"}
        onBtnPress={() => {
          setScheduleSuccessModal(false);
        }}
        headingClass={styles.modalHeading}
      >
        <TextComponent
          text={"10:00 AM to 11:00 AM"}
          style={{ fontFamily: "Urbanist-semibold", marginBottom: "10px" }}
        />
      </Modal>

      {/* /////////////////////////Unable to schedule///////////////////////// */}

      <Modal
        open={scheduleDeniedModal}
        onCancel={() => setScheduleDeniedModal(false)}
        icon={
          <IoWarningOutline
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Unable to Schedule"}
        width={"400px"}
        buttonTitle={"Go back"}
        onBtnPress={() => setScheduleDeniedModal(false)}
      >
        <TextComponent
          text={"immobilizer is already schedule on this time"}
          style={{ fontFamily: "Urbanist-semibold", marginBottom: "10px" }}
        />
      </Modal>

      {/* /////////////////////////Delete Module Modal///////////////////////// */}

      <Modal
        open={removeModuleModal}
        onCancel={() => setRemoveModuleModal(false)}
        icon={
          <img
            src={questionIcon}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Are you sure"}
        width={"400px"}
        twoButton
        okBtnTitle={"Yes, Remove"}
        cancelBtnTitle={"No, go back"}
        btnDiv={styles.access_modalBtn}
        onClickCancelButton={() => {
          setRemoveModuleModal(false);
        }}
        onClickOkButton={() => {
          dispatch(AssetsMiddleware.deleteModule({ id: details?.id })).then(
            () => {
              setRemoveModuleModal(false);
              setModuleSuccessModal(true);
              setOpen(false);
              setDetails([]);
            },
          );
        }}
        btnStyle={{ width: "80%" }}
      >
        <TextComponent
          text={"You want to remove this device?"}
          style={{ fontFamily: "Urbanist-semibold", marginBottom: "10px" }}
        />
      </Modal>

      {/* /////////////////////////Delete Device Successfull///////////////////////// */}

      <Modal
        open={moduleSuccessModal}
        onCancel={() => setModuleSuccessModal(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Device removed"}
        width={"400px"}
        buttonTitle={"Continue"}
        onBtnPress={() => {
          setModuleSuccessModal(false);
        }}
        headingClass={styles.modalHeading}
      ></Modal>

      {/* /////////////////////////Asset Assigned Modal///////////////////////// */}

      <Modal
        open={assignAssetsModal}
        onCancel={() => setAssignAssetsModal(false)}
        imageClass={styles.assignAssetsImgStyle}
        icon={
          <img
            src={assetsAssignImg}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        width={"600px"}
        twoButton
        okBtnTitle={"Add new vehicle"}
        cancelBtnTitle={"Go Back"}
        leftBtnIcon={
          <FaCirclePlus
            size={15}
            color="var(--white-color)"
            style={{ marginRight: "5px" }}
          />
        }
        btnDiv={styles.access_modalBtn}
        onClickCancelButton={() => {
          setAssignAssetsModal(false);
        }}
        onClickOkButton={() => {
          setAssignAssetsModal(false);
          setOpenAddAssetsModal(true);
        }}
        headingClass={styles.modalHeading}
      >
        <>
          <TextComponent
            text={"Assign Vehicle"}
            style={{
              fontFamily: "Urbanist-bold",
              fontSize: "var(--heading2-font-size)",
            }}
          />
          <div className={styles.assetsCont}>
            <List
              dataSource={getUnlinkAssets?.data}
              renderItem={(item, index) => (
                <div className={styles.assetsItemDiv} key={index}>
                  {" "}
                  <div className={styles.assetslistItem} key={index}>
                    <div className={styles.assetsImgDiv}>
                      <img src={item?.image ? item?.image : imagePlaceholder} />
                      <div className={styles.assetslistText}>
                        {/* <div className={styles.assetslistTextTop}> */}
                        <TextComponent
                          text={`Model: ${item?.model ? item?.model : "--"}`}
                          style={{
                            fontFamily: "Urbanist-bold",
                            fontSize: "var(--mobile-heading)",
                          }}
                        />
                        <TextComponent
                          text={`Make: ${item?.make ? item?.make : "--"}`}
                          style={{
                            fontFamily: "Urbanist-bold",
                            fontSize: "var(--mobile-heading)",
                          }}
                        />
                        {/* </div> */}
                        {/* <div className={styles.assetslistTextTop}> */}
                        <TextComponent
                          text={`VIN: ${item?.vin_no ? item?.vin_no?.toString().slice(-8) : "--"}`}
                          style={{
                            fontFamily: "Urbanist-bold",
                            fontSize: "var(--mobile-heading)",
                          }}
                        />
                        <TextComponent
                          text={`Stock No: ${item?.stock_no ? item?.stock_no : "--"}`}
                          style={{
                            fontFamily: "Urbanist-bold",
                            fontSize: "var(--mobile-heading)",
                          }}
                        />
                        {/* </div> */}
                      </div>
                    </div>
                  </div>
                  <SubmitButton
                    secondaryBtn
                    title={"Assign"}
                    style={{ marginTop: "10px" }}
                    onClick={() => {
                      dispatch(
                        AssetsMiddleware.assignAsset({
                          assetId: item?.id,
                          deviceId: details?.device_id,
                        }),
                      ).then(() => {
                        setAssetsSuccessModal(true);
                        setAssignAssetsModal(false);
                        setOpen(false);
                        setDetails([]);
                      });
                    }}
                  />
                </div>
              )}
            />
          </div>
        </>
      </Modal>

      {/* /////////////////////////Asset Assigned Successfull///////////////////////// */}
      <Modal
        open={assetsSuccessModal}
        onCancel={() => setAssetsSuccessModal(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Asset Assigned successfully"}
        width={"400px"}
        buttonTitle={"Continue"}
        onBtnPress={() => {
          setAssetsSuccessModal(false);
        }}
        headingClass={styles.modalHeading}
      ></Modal>

      {/* /////////////////////////Location Tracking///////////////////////// */}

      <Modal
        title={"Location Tracking"}
        open={locationTracking}
        onCancel={() => setLocationTracking(false)}
        width={"600px"}
      >
        <div className={styles.track_mainCont}>
          <div className={styles.track_header}>
            <TextComponent
              text={"Vehicle is 500m away from set location"}
              style={{ fontSize: "var(--mobile-sub-heading)" }}
            />
            <div className={styles.track_subHeader}>
              <div
                className={styles.track_subChildHeader}
                style={{ borderRight: "1px solid var(--border-color)" }}
              >
                <TextComponent
                  text={"Lot A, Row 5"}
                  style={{
                    fontFamily: "Urbanist-bold",
                    fontSize: "var(--paragraph-font-size)",
                  }}
                />
                <TextComponent
                  text={"Location"}
                  style={{
                    fontSize: "var(--mobile-sub-heading)",
                    fontFamily: "Urbanist-regular",
                  }}
                />
              </div>
              <div className={styles.track_subChildHeader}>
                <TextComponent
                  text={"17th street"}
                  style={{
                    fontFamily: "Urbanist-bold",
                    fontSize: "var(--paragraph-font-size)",
                  }}
                />
                <TextComponent
                  text={"Current Location"}
                  style={{
                    fontSize: "var(--mobile-sub-heading)",
                    fontFamily: "Urbanist-regular",
                  }}
                />
              </div>
            </div>
          </div>
          <div className={styles.track_mapCont}>
            <img
              src={mapImg}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "10px",
              }}
            />
          </div>
        </div>
      </Modal>

      <Modal
        open={addModule}
        onCancel={() => setAddModule(false)}
        icon={<TbDeviceRemote size={100} />}
        title={"Create Device"}
        width={"800px"}
        twoButton
        okBtnTitle={"Create"}
        cancelBtnTitle={"Go back"}
        btnDiv={styles.access_modalBtn}
        onClickCancelButton={() => {
          setAddModule(false);
        }}
        onClickOkButton={onCreateModule}
        btnStyle={{ width: "80%" }}
      >
        <div className={styles.modalCont}>
          {/* <InputField
            label={"Device Name"}
            placeholder={"Write here"}
            value={device_name}
            onChange={(e) => setDevice_name(e.target.value)}
          /> */}
          <InputField
            label={"Device Id"}
            placeholder={"Write here"}
            value={device_id}
            onChange={(e) => setDevice_id(e.target.value)}
          />
          {/* <div className={styles.formDivideInput}>
            <img
              className={styles.slectImg}
              onClick={() => moduleImageref.current.click()}
              src={
                moduleImage ? URL.createObjectURL(moduleImage) : uploadPicture
              }
              alt=""
            />
            <input
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              ref={moduleImageref}
              onChange={(e) => setModuleImage(e.target.files[0])}
            />
          </div> */}
        </div>
      </Modal>
      <AddAssets
        isOpen={openAddAssetsModal}
        setIsOpen={setOpenAddAssetsModal}
      />
    </div>
  );
};

export default Inventory;
